.EventInstitutionCardImage {
  object-fit: cover;
  width: 100%;
  height: 5rem;
}

.ProviderBlock {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0.5rem;

  & img {
    object-fit: cover;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 9999px;
  }
}

.CardHeader {
  display: flex;
  justify-content: space-between;
}

.SmallerText {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
  font-size: 0.875rem;
}

.ShowMoreLess {
  cursor: pointer;
  color: var(--bs-primary-color);
  font-size: 0.875rem;
  text-decoration: underline;
}
